import { Button } from '@/components/ui/button';

type EvoHubConnectPanelProps = {
  connectUrl: string | null;
  status: string;
  linkedAt?: string | null;
  lastError?: string | null;
};

export function EvoHubConnectPanel({
  connectUrl,
  status,
  linkedAt,
  lastError,
}: EvoHubConnectPanelProps) {
  const openConnect = () => {
    if (!connectUrl) {
      return;
    }
    window.open(connectUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='space-y-3 rounded-md border p-4'>
      <div className='text-sm'>
        <span className='font-medium'>Estado:</span> {status}
      </div>
      {linkedAt ? (
        <div className='text-sm text-muted-foreground'>
          Conectado: {new Date(linkedAt).toLocaleString()}
        </div>
      ) : null}
      {lastError ? <div className='text-sm text-destructive'>{lastError}</div> : null}
      <p className='text-sm text-muted-foreground'>
        Abrí el enlace de Evo Hub para que el cliente conecte su cuenta Meta (Embedded Signup).
      </p>
      <Button type='button' onClick={openConnect} disabled={!connectUrl}>
        Abrir conexión Meta
      </Button>
      {connectUrl ? (
        <p className='break-all text-xs text-muted-foreground'>{connectUrl}</p>
      ) : null}
    </div>
  );
}
